/**
 * ABWIN Scratch Popup — Bootstrap
 * ---------------------------------------------------------------
 * Wires the popup into the page.
 */
(function () {
  "use strict";

  function boot() {
    const popup = new window.AbwinScratchPopup();
    popup.scheduleTrigger();

    window.AbwinDevTools = {
      openNow: () => popup.open(),
      close: () => popup.close("dev_tool"),
      resetFrequency: () => window.AbwinStorage.resetAll(),
      getState: () => popup.state,
    };
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
